import * as moment from 'moment';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { useRecoilValue } from 'recoil';
import { AUsers } from '../../../../../atoms/global/users';
import { Loader } from '../../../../../styles/global/css/GlobalLoader';
import { translateToString } from '../../../../../styles/global/translate';
import { FormInstance, FormInstanceAndFormId, getLinkedFormInstance } from '../../../../forms/actions';
import { InstancePopup } from '../../../../forms/formInstancePopup';
import { LoadingStateEnum } from '../../../../import/model';
import RestrictedAllowDenyList from '../../../../permissions/RestrictedAllowDenyList';
import { ModalState } from '../../../../products/model';
import { ListContainer, ListTitle } from '../../../style/LinkedElementStyle';
import { NoDataText } from '../../../style/Style';
import LinkedElementCard, { CardAvatar, CardViewButton } from '../LinkedElementCard';
import { CardList, SeeMore } from '../style/LinkedElementStyle';

function FormList(props: { linkedInstances: FormInstance[], isExtend?: boolean }): JSX.Element {
	const DEFAULT_LIMIT = 3;

	const [offset, setOffset] = React.useState<number>(0);
	const [isOpen, setIsOpen] = React.useState<boolean>(false);
	const [modalState, setModalState] = React.useState<ModalState<string>>({ isOpen: false });
	const users = useRecoilValue(AUsers);

	const instances = [...props.linkedInstances].sort((a, b) => new Date(b.made_at).getTime() - new Date(a.made_at).getTime());

	return <>
		<ListContainer onClick={() => setIsOpen(!isOpen)}>
			<ListTitle isOpen={isOpen} label={props.linkedInstances[0].name} amount={props.linkedInstances.length} />
		</ListContainer>

		{isOpen && <CardList>
			{instances.length === 0 && <NoDataText><Translate id='no_linked_forms' /></NoDataText>}
			{instances.slice(0, DEFAULT_LIMIT + offset).map(row => {
				const user = users.find(u => u.id == row.created_by);
				return <LinkedElementCard
					key={row.uuid}
					isExtend={props.isExtend}
					onClick={() => setModalState({ isOpen: true, fullOpenMode: true, data: row.uuid })}
					avatar={<CardAvatar photo={user?.photoUrl} name={user?.name ?? ''} userId={row.created_by} />}
					title={row.name}
					lines={[
						translateToString('by_on').replace('{{NAME}}', user?.name ?? '').replace('{{DATE}}', moment.utc(row.made_at).local().format('LLL')),
						translateToString(row.progression < 100 ? 'draft' : 'completed')
					]}
					actions={<CardViewButton onClick={() => setModalState({ isOpen: true, fullOpenMode: false, data: row.uuid })} />}
				/>;
			})}
			{instances.length > DEFAULT_LIMIT + offset &&
				<SeeMore onClick={() => setOffset(offset + DEFAULT_LIMIT)}><Translate id='see_more' /></SeeMore>
			}
			<InstancePopup
				modalState={modalState}
				isOpen={modalState.isOpen}
				onClickOut={() => setModalState({ isOpen: false })}
			/>
		</CardList>}
	</>;
}

function LinkedForms(props: {
	company_id: number
	isExtend?: boolean
}): JSX.Element {
	const [linkedInstances, setLinkedInstances] = React.useState<{ [key: string]: FormInstanceAndFormId[] }>();
	const [loadingState, setLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADING);

	React.useEffect(() => {
		getLinkedFormInstance(props.company_id).then(res => {
			setLinkedInstances(res);
			setLoadingState(LoadingStateEnum.LOADED);
		});
	}, []);

	if (loadingState == LoadingStateEnum.LOADING) {
		return <Loader width='30px' />;
	}
	return <>
		{linkedInstances && Object.keys(linkedInstances).map(key => {
			return <RestrictedAllowDenyList target_id={linkedInstances?.[key]?.[0]?.form_id} key={key} target='ReadForm' >
				<FormList linkedInstances={linkedInstances[key]} isExtend={props.isExtend} />
			</RestrictedAllowDenyList>;
		})}
	</>;
}

export default LinkedForms;
